<template>
  <BaseDialog
    v-model="showDialog"
    content-width="600px"
    @click:outside="cancelClick"
  >
    <BaseCard class="m_border-none m_bg-white">
      <v-card-title
        v-if="title.length"
        class="text-h5"
      >
        {{ title }}
      </v-card-title>
      <v-card-text v-if="text.length">
        {{ text }}
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          color="var(--pageSuccessFont)"
          text
          @click="cancelByButton"
        >
          {{ cancelText }}
        </v-btn>
      </v-card-actions>
    </BaseCard>
  </BaseDialog>
</template>

<script>
import emitter from '@/shared/services/emitter';
import BaseDialog from '@/shared/lib/uikit/components/BaseDialog/BaseDialog.vue';
import BaseCard from '@/shared/lib/uikit/components/BaseCard/BaseCard.vue';

export default {
  name: 'AppInfoDialog',
  components: { BaseCard, BaseDialog },
  data() {
    return {
      showDialog: false,
      title: '',
      text: '',
      cancelText: '',
      afterCloseByButton: null,
    };
  },
  created() {
    emitter.on('openInfoDialog', data => {
      this.show(data);
    });
  },
  methods: {
    show(data) {
      this.showDialog = true;
      this.title = data.title || '';
      this.text = data.text || '';
      this.cancelText = data.cancelText || 'Хорошо';
      this.afterCloseByButton = data.afterCloseByButton || null;
    },
    cancelByButton() {
      if (typeof (this.afterCloseByButton) === 'function') {
        this.afterCloseByButton();
      }
      this.cancelClick();
    },
    cancelClick() {
      this.returnDefaultData();
    },
    returnDefaultData() {
      this.showDialog = false;
      this.title = '';
      this.text = '';
      this.cancelText = '';
      this.afterCloseByButton = null;
      emitter.emit('closeInfoDialog', {});
    },
  },
};
</script>
